import React from 'react';
import { api_route, user_logout } from '../helpers/Global';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

class Messages extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            scrolling: true,
            count_messages: 0,
            btn_loading_text: '',
            time_param: '',
            refresh_data: 'init',
            page: 1,
            messages: [],
        }
        this.handleScroll = this.handleScroll.bind(this);
    }
    
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        this.componentDidUpdate();
    }
    
    
    componentDidUpdate() {
        var params = queryString.parse(this.props.location.search);
        var time_param = params.t;

        if (this.state.time_param !== time_param || this.state.refresh_data) {

            var page = this.state.page;
            var init_list = false;
            if (this.state.time_param !== time_param || this.state.refresh_data === 'init') {
                this.setState({ page: 1 });
                init_list = true;
                page = 1;
            }

            if (init_list && params.loader !== 'false') {
                this.props.loaderDisplay(true);
            }
          
            
            fetch(api_route('liste-messages') + '&page=' + page, { method: 'GET' })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp.response === 'error-connected') {
                        user_logout();
                        this.props.history.push(`/user-logout`);
                        this.props.loaderDisplay(false);
                    } else if (resp['liste-messages']) {

                        var count_messages = resp['total-messages'];
                        this.setState({
                            messages: (init_list ? resp['liste-messages'] : this.state.messages.concat(resp['liste-messages'])),
                            count_messages: count_messages
                        }, function () {

                            this.setState({
                                btn_loading_text: (this.state.messages.length !== count_messages ? 'Afficher plus' : null),
                            }, function () {
                                if (this.state.btn_loading_text && document.getElementById('btnLoadMore')) {
                                    document.getElementById('btnLoadMore').classList.remove('disabled');
                                }

                                if (resp['info-general']) {
                                    this.props.setLivreur(resp['info-general']);
                                }
                            });

                            this.props.loaderDisplay(false);
                        });
                    }
                })
               .catch(err => {
                    this.props.loaderDisplay(false);
                    this.props.openErrorSystem(true);
                })
            
            this.setState({
                time_param: time_param,
                refresh_data: false,
                scrolling: true,
            });

        }
    }
    
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    
    handleScroll() {
        if (this.state.scrolling) {
            const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
            const body = document.body;
            const html = document.documentElement;

            const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            const windowBottom = windowHeight + window.pageYOffset;
            if (windowBottom >= docHeight) {
                this.loadMore();
            }
        }
    }


    render() {
        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity" style={{ height: 'auto' }}>
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">Messages / Réclamations</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="container">
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-header">
                                <h6>Liste des messages</h6>
                            </div>
                            <div className="card-body">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>{this.state.count_messages} Messages</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.messages.map((rowmessage, indice) =>
                                            <React.Fragment key={indice + rowmessage.id}>
                                                <tr className="show-info-colis" onClick={() => this.showDetailsMessage( rowmessage.colis_barecode)}>
                                                    <td className="footable-first-visible p-relative">
                                                        <h6 className="d-inline-block vm" style={{ 'lineHeight': '22px', 'width': '90%', 'float': 'right' }}>
                                                            <small>{rowmessage.created_by}</small><br />
                                                            <small>{rowmessage.created_at}</small><br />
                                                            <small className='text-danger'>Colis N°{rowmessage.colis_barecode}</small><br /><br />
                                                            

                                                             {rowmessage.message && (
                                                                <React.Fragment>  
                                                                    <span className='text-success' style={{ 'fontSize': '14px' }}>
                                                                    {React.createElement('b', { dangerouslySetInnerHTML: { __html: rowmessage.message } })}
                                                                    </span><br />
                                                                </React.Fragment>
                                                            )}
                                                        
                                                           

                                                        </h6>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )}

                                    </tbody>
                                </table>
                                {this.state.btn_loading_text && (
                                    <button type="button" id="btnLoadMore" className="btn btn-light btn-block" onClick={() => this.loadMore()}>{this.state.btn_loading_text}</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }
    
 

   showDetailsMessage = (barecode) => {
        this.props.history.push(`/colis-message?colis=` + barecode + '&readmessage=1&t=' + Date.now());
        this.setState({ search_form: false });
    }


   
    loadMore = () => {
        if (this.state.btn_loading_text) {
            const page = this.state.page + 1
            this.setState({
                page: page,
                refresh_data: true,
                btn_loading_text: 'Loading...'
            }, function () {
                var btn = document.getElementById('btnLoadMore');
                if (btn) btn.classList.add('disabled');
            });
        }
    }

}

export default withRouter(Messages);